import DatasetSettings from './DatasetSettings';

export default DatasetSettings;
